module.exports = __webpack_public_path__ + "49e8d412eb7968d758d77077702bcf97.pdf";